import { render, staticRenderFns } from "./validation-messages-box.vue?vue&type=template&id=f364d2c8&scoped=true&"
import script from "./validation-messages-box.vue?vue&type=script&lang=ts&"
export * from "./validation-messages-box.vue?vue&type=script&lang=ts&"
import style0 from "./validation-messages-box.vue?vue&type=style&index=0&id=f364d2c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f364d2c8",
  null
  
)

export default component.exports